import http from "@/http-common";

class EvaluationMigrationService {
    migrateDaily(data) {
        return http.post("/evaluation/migration/daily", data);
    }

    migrateWeekly(data) {
        return http.post("/evaluation/migration/weekly", data);
    }

    migrateMonthly(data) {
        return http.post("/evaluation/migration/monthly", data);
    }

    migratePeriodic(data) {
        return http.post("/evaluation/migration/periodic", data);
    }
}

export default new EvaluationMigrationService();
